import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { deleteTatInfo, getConditionCosts, getCurrencies, getPartConditions, getPartVendors, getSpecificCost, getTATInfo, saveCostsReq, saveTatInfo } from "../../../../modules/ConfigurationModule/services/SupplyChainService";
import { HTTP_RESPONSE_CODES } from "../../../../globals/globals";
import { load } from "@amcharts/amcharts5/.internal/core/util/Net";
const defaultRangeItem = {
    id: null,
    range: "",
    unitCost: null,
    version: 0,
}
const conditionProp = {
    "C": "partConditionId",
    "R": "repairTypeId"
}
export const vendorCostSlice = createSlice({
    name: "vendorCost",
    initialState: {
        vendors: [],
        selectedVendor: {},

        // vendor information [array] by temporal Id
        vendorConditions: {},

        idxVendors: {},
        loading: false,

        //selected condition
        tab: null,

        // aavailable conditions
        conditions: [],
        idxConditions: {},


        editingStatus: {},
        costType: "",
        unsaved: {},
        vendorParams: {orderBy: "", search: ""},
        vendor1stReq: true
    },
    reducers: {
        resetSlice: (state, action) => {
            return {
                vendors: [],
                selectedVendor: {},
                vendorConditions: {},
                idxVendors: {},
                loading: false,
                tab: null,
                conditions: [],
                idxConditions: {},
                editingStatus: {},
                costType: "",
                vendorParams: {orderBy: "", search: ""},
                vendor1stReq: true
            }
        },
        updateCostType: (state, action) => {
            return {
                ...state,
                costType: action.payload
            }
        },
        updateVendorParams: (state, action) => {
            let {name, value} = action.payload;
            return {...state, vendorParams: {...state.vendorParams, [name]:value}};
        },
        startEdition: (state, action) => {
            let { vendorTempId } = action.payload;
            return { ...state, editingStatus: { ...state.editingStatus, [vendorTempId]: true } }
        },
        cancelEdition: (state, action) => {
            let { vendorTempId } = action.payload;
            return { ...state, editingStatus: { ...state.editingStatus, [vendorTempId]: false } }
        },
        selectVendor: (state, action) => {
            return { ...state, selectedVendor: action.payload };
        },
        tabChange: (state, action) => {
            return { ...state, tab: action.payload }
        },
        vendorChange: (state, action) => {
            let { newVendor } = action.payload;
            let vendors = [...state.vendors];
            let selectedVendor = { ...state.selectedVendor, vendorName: newVendor.name, vendorId: newVendor.id };
            let vendorIdx = vendors.findIndex(v => v.tempId === selectedVendor.tempId);
            vendors[vendorIdx] = { ...vendors[vendorIdx], vendorName: newVendor.name, vendorId: newVendor.id, identificationNumber:newVendor.identification_number };

            let vendorConditions = [...(state.vendorConditions[selectedVendor.tempId] ?? [])]?.map(c => ({ ...c, vendorId: newVendor.id })) ?? [];
            return { ...state, vendors, selectedVendor, vendorConditions: { ...state.vendorConditions, [selectedVendor.tempId]: vendorConditions } };
        },
        updateVendorCondition: (state, action) => {
            let { vendorTempId, conditionIdx, name, value } = action.payload;
            let vendorConditions = [...state.vendorConditions[vendorTempId]];
            vendorConditions[conditionIdx] = { ...vendorConditions[conditionIdx], [name]: value };
            return {
                ...state,
                vendorConditions: {
                    ...state.vendorConditions,
                    [vendorTempId]: vendorConditions
                }
            }
        },
        discardCondition: (state, action) => {
            let { vendorTempId, conditionId, partConditionId } = action.payload;
            let costType = state.costType;
            let tabs = state.idxConditions;
            let vendorConditions = [...state.vendorConditions[vendorTempId]];
            if (typeof(conditionId) === 'number') {
                vendorConditions = vendorConditions.filter(c => !(c.id === conditionId))
            } else {
                vendorConditions = vendorConditions.filter(c => !(c[conditionProp[costType]] === partConditionId));
            }
            let tab = {...tabs[{...[...vendorConditions][0]}[conditionProp[costType]]]} ?? null;
            // console.warn('*new tab',costType, conditionProp[costType], {...tabs[{...[...vendorConditions][0]}[conditionProp[costType]]]});
            return {
                ...state,
                vendorConditions: {
                    ...state.vendorConditions,
                    [vendorTempId]: vendorConditions
                },
                tab: tab
            }
        },
        updateCostItem: (state, action) => {
            let { vendorTempId, conditionIdx, historyIdx, name, value } = action.payload;
            let vendorConditions = [...state.vendorConditions[vendorTempId]];
            let history = [...vendorConditions[conditionIdx].conditionCosts];
            history[historyIdx] = { ...history[historyIdx], [name]: value, edited: true };
            vendorConditions[conditionIdx] = { ...vendorConditions[conditionIdx], conditionCosts: [...history] };
            return {
                ...state,
                vendorConditions: {
                    ...state.vendorConditions,
                    [vendorTempId]: vendorConditions
                }
            }
        },
        updateRange: (state, action) => {

            let { vendorTempId, conditionIdx, historyIdx, name, value, rangeIdx } = action.payload;
            let vendorConditions = [...state.vendorConditions[vendorTempId]];
            let history = [...vendorConditions[conditionIdx].conditionCosts];
            let ranges = [...history[historyIdx].ranges];
            ranges[rangeIdx] = { ...ranges[rangeIdx], [name]: value };
            history[historyIdx] = { ...history[historyIdx], ranges: ranges, edited: true };
            vendorConditions[conditionIdx] = { ...vendorConditions[conditionIdx], conditionCosts: [...history] };
            return {
                ...state,
                vendorConditions: {
                    ...state.vendorConditions,
                    [vendorTempId]: vendorConditions
                }
            }
        },
        addRange: (state, action) => {

            let { vendorTempId, conditionIdx, historyIdx } = action.payload;
            let vendorConditions = [...state.vendorConditions[vendorTempId]];
            let history = [...vendorConditions[conditionIdx].conditionCosts];
            let ranges = [...history[historyIdx].ranges];
            history[historyIdx] = { ...history[historyIdx], unitCosts: [...ranges, { ...defaultRangeItem }], ranges: [...ranges, { ...defaultRangeItem }] };
            vendorConditions[conditionIdx] = { ...vendorConditions[conditionIdx], conditionCosts: [...history] };
            return {
                ...state,
                vendorConditions: {
                    ...state.vendorConditions,
                    [vendorTempId]: vendorConditions
                }
            }
        },
        removeRange: (state, action) => {

            let { vendorTempId, conditionIdx, historyIdx, at } = action.payload;
            let vendorConditions = [...state.vendorConditions[vendorTempId]];
            let history = [...vendorConditions[conditionIdx].conditionCosts];
            let ranges = [...history[historyIdx].ranges].filter((i, j) => !(j === at));
            history[historyIdx] = { ...history[historyIdx], unitCosts: ranges, ranges: ranges };
            vendorConditions[conditionIdx] = { ...vendorConditions[conditionIdx], conditionCosts: [...history] };
            return {
                ...state,
                vendorConditions: {
                    ...state.vendorConditions,
                    [vendorTempId]: vendorConditions
                }
            }
        },
        currencyChange: (state, action) => {

            let { newCurrency } = action.payload;
            let vendors = [...state.vendors];
            let selectedVendor = { ...state.selectedVendor, currencyId: newCurrency.id };
            let vendorIdx = vendors.findIndex(v => v.tempId === selectedVendor.tempId);
            vendors[vendorIdx] = { ...vendors[vendorIdx], currencyId: newCurrency.id };
            let vendorConditions = [...(state.vendorConditions[selectedVendor.tempId] ?? [])]?.map(c => ({ ...c, currencyId: newCurrency.id })) ?? [];
            return { ...state, vendors, selectedVendor, vendorConditions: { ...state.vendorConditions, [selectedVendor.tempId]: vendorConditions } };
        },

        addCost: (state, action) => {

            let { vendorTempId } = action.payload;
            let vendorConditions = [...state.vendorConditions[vendorTempId]];
            let costType = state.costType;
            let conditionIdx = vendorConditions.findIndex(c => c[conditionProp[costType]] === state.tab.id);
            let history = [{ ...defaultHistoryPrice() }, ...vendorConditions[conditionIdx].conditionCosts];
            vendorConditions[conditionIdx] = { ...vendorConditions[conditionIdx], conditionCosts: [...history] };
            return {
                ...state,
                vendorConditions: {
                    ...state.vendorConditions,
                    [vendorTempId]: vendorConditions
                }
            }
        },

        addNewVendor: (state, action) => {
            let newVendor = { tempId: crypto.randomUUID(), vendorId: null, currencyId: null, identificationNumber: null, partId: null, vendorName: "" };
            return {
                ...state,
                vendors: [newVendor, ...state.vendors],
                selectedVendor: newVendor,
                editingStatus: {...state.editingStatus, [newVendor.tempId]: true }
            }

        },
        applyConditions: (state, action) => {
            let { deleteConditions, newConditions, vendorTempId, costType } = action.payload;

            if (newConditions.length > 0) {
                let newTab = state.conditions.find(c => c.id === newConditions[newConditions.length - 1]);
                let merged = [...(state.vendorConditions[vendorTempId]?.filter(c => !(deleteConditions.includes(c[conditionProp[costType]]))) ?? []), ...newConditions.map(cId => ({ ...defaultTat(costType), [conditionProp[costType]]: cId }))]
                return {
                    ...state,
                    tab: newTab,
                    vendorConditions: {
                        ...state.vendorConditions,
                        [vendorTempId]: merged
                    }
                }
            } else {
                if (deleteConditions.includes(state.tab.id)) {
                    let remaining = state.vendorConditions[vendorTempId].filter(c => !(deleteConditions.includes(c[conditionProp[costType]])));
                    let newTab = remaining.length > 0 ? (state.conditions.find(c => c.id === remaining[0][conditionProp[costType]])) : null;
                    return {
                        ...state,
                        vendorConditions: {
                            ...state.vendorConditions,
                            [vendorTempId]: [...remaining]
                        },
                        tab: newTab
                    }
                } else {
                    let remaining = state.vendorConditions[vendorTempId].filter(c => !(deleteConditions.includes(c[conditionProp[costType]])));
                    return {
                        ...state,
                        vendorConditions: {
                            ...state.vendorConditions,
                            [vendorTempId]: [...remaining]
                        },
                    }
                }
            }

            if (deleteConditions.includes(state.tab.id)) {
                let newTab;
                if (newConditions.length > 0) {
                    newTab = state.conditions.find(c => c.id === newConditions[newConditions.length - 1]);
                } else {
                    let mrgNew = [...state.vendorConditions[vendorTempId].map(vC => vC[conditionProp[costType]]), ...newConditions]
                    newTab = mrgNew.length > 0 ? (state.conditions.find(c => c.id === mrgNew[0]) ?? null) : null;
                }
                let merged = [...state.vendorConditions[vendorTempId].filter(c => !(deleteConditions.includes(c.id))), ...newConditions.map(cId => ({ ...defaultTat, [conditionProp[costType]]: cId }))]
                return {
                    ...state,
                    tab: newTab,
                    vendorConditions: {
                        ...state.vendorConditions,
                        [vendorTempId]: merged
                    }
                }
            } else {

            }

        }
    },
    extraReducers: (builder) => {
        builder.addCase(fetchVendorsForCost.fulfilled, (state, action) => {
            let vendor1stReq = state.vendor1stReq;
            let prevVendors = state.vendors;
            let vendors = action.payload.map(v => ({ ...v, tempId: prevVendors.find(qv => qv.vendorId === v.vendorId)?.tempId ?? crypto.randomUUID() }));
            if (vendors.length > 0 || !vendor1stReq) {
                let idxVendors = Object.fromEntries(vendors.map(v => [v.tempId, v]));
                if (vendor1stReq) {
                    return { ...state, vendors, idxVendors, selectedVendor: vendors[0], vendor1stReq: false };
                } else {
                    return { ...state, vendors, idxVendors, vendor1stReq: false };
                }
            } else {
                let newVendor = { tempId: crypto.randomUUID(), vendorId: null, identificationNumber: null, partId: null, vendorName: "" };
                return { ...state, vendors: [newVendor], selectedVendor: newVendor, editingStatus: { [newVendor.tempId]: true }, vendor1stReq: false }
            }

        });
        builder.addCase(fetchConditions.fulfilled, (state, action) => {
            let { conditions, costType } = action.payload;
            let idxConditions = Object.fromEntries(conditions.map(c => [c.id, c]));
            return { ...state, conditions, idxConditions, costType }
        });


        builder.addCase(fetchConditionCosts.fulfilled, (state, action) => {
            let { load, vendorTempId, conditionId, conditionIdx } = action.payload;
            let vendorConditions = [...state.vendorConditions[vendorTempId]];
            vendorConditions[conditionIdx] = { ...vendorConditions[conditionIdx], conditionCosts: [...(vendorConditions[conditionIdx]?.conditionCosts ?? []).filter(c => c.isNew), ...load] };
            return {
                ...state,
                vendorConditions: {
                    ...state.vendorConditions,
                    [vendorTempId]: vendorConditions
                }
            };
        });


        // builder.addCase(fetchConditionsCosts.fulfilled, (state,action) => {
        //     let {loads, vendorTempId} = action.payload;
        //     return {
        //         ...state,
        //         conditionCosts: {
        //             ...state.conditionCosts,
        //             [vendorTempId]: Object.fromEntries(loads.map(l => [l.partConditionId, l]))
        //         }
        //     }
        // });
        builder.addCase(fetchTATInfo.pending, (state, action) => {
            return { ...state, loading: true };
            // return { ...state }
        });
        builder.addCase(fetchTATInfo.fulfilled, (state, action) => {
            let { load, vendorId, vendorTempId, currencyId, preSelectedTab } = action.payload;

            return {
                ...state,
                loading: false,
                tab: preSelectedTab,
                selectedVendor: { ...state.selectedVendor, vendorId, currencyId },
                vendorConditions: { ...state.vendorConditions, [vendorTempId]: load }
            }
        });
        builder.addCase(fetchTATInfo.rejected, (state, action) => {
            return { ...state, loading: false };
        });

        // !

        // builder.addCase(saveTATInfo.fulfilled, (state, action) => {
        //     return { ...state };
        //     let { load, closeEdition, vendorTempId } = action.payload;
        //     if (closeEdition) {
        //         return { ...state, editingStatus: { ...state.editingStatus, [vendorTempId]: false }, tatInfo: { ...(state.tatInfo ?? {}), [vendorTempId]: load } }
        //     }
        //     else {
        //         return { ...state, tatInfo: { ...(state.tatInfo ?? {}), [vendorTempId]: load } }

        //     }

        //     // return {...state};
        //     // let { data, closeEdition, vendorTempId } = action.payload;

        //     // let { load } = data;
        //     // let { vendorId, partConditionId } = load;
        //     // if (closeEdition) {
        //     //     return { ...state, editingStatus: { ...state.editingStatus, [vendorTempId]: { ...(state.editingStatus[vendorTempId] ?? {}), [partConditionId]: false } }, tatInfo: { ...(state.tatInfo ?? {}), [vendorTempId]: { ...(state.tatInfo?.[vendorTempId] ?? {}), [partConditionId]: { ...load } } } }
        //     // }
        //     // return { ...state, tatInfo: { ...(state.tatInfo ?? {}), [vendorTempId]: { ...(state.tatInfo?.[vendorTempId] ?? {}), [partConditionId]: { ...load } } } }
        // });
        builder.addCase(deleteTATInfo.fulfilled, (state, action) => {
            return { ...state };
            let { vendorTempId, conditionId } = action.payload;
            let copy = { ...state.tatInfo[vendorTempId] };
            delete copy[conditionId];
            return { ...state, tatInfo: { ...state.tatInfo, [vendorTempId]: { ...copy } } };
        });
        // builder.addCase(saveCosts.fulfilled, (state, action) => {
        //     return { ...state }
        //     let { loads, messages, codes, vendorTempId, conditionId } = action.payload;
        //     console.warn('*action payload', loads, vendorTempId, conditionId);
        //     return {
        //         ...state,
        //         conditionCosts: {
        //             ...state.conditionCosts,
        //             [vendorTempId]: {
        //                 ...(state.conditionCosts[vendorTempId] ?? {}),
        //                 [conditionId]: loads
        //             }
        //         }

        //     }

        // });

        builder.addCase(fetchCurrencies.fulfilled, (state, action) => {
            let currencies = Object.fromEntries(action.payload.map(c => [c.id, c]));
            return {
                ...state,
                currencies: currencies
            }
        });

        builder.addCase(fetchRanges.fulfilled, (state, action) => {
            let { conditionIdx, historyIdx, vendorTempId, load } = action.payload;

            let vendorConditions = [...state.vendorConditions[vendorTempId]];
            let costHistory = [...state.vendorConditions[vendorTempId][conditionIdx].conditionCosts];
            costHistory[historyIdx] = { ...costHistory[historyIdx], ranges: load };
            vendorConditions[conditionIdx] = { ...vendorConditions[conditionIdx], conditionCosts: costHistory };
            return {
                ...state,
                vendorConditions: {
                    ...state.vendorConditions,
                    [vendorTempId]: vendorConditions
                }
            };
        });

        builder.addCase(saveVendor.fulfilled, (state, action) => {
            let { conditionResponses, vendorTempId, closeEdition, prevConditions } = action.payload;
            let errors = conditionResponses.reduce((acc, cr) => [HTTP_RESPONSE_CODES.CREATED, HTTP_RESPONSE_CODES.SUCCESS, HTTP_RESPONSE_CODES.UPDATED].includes(cr.data.responseCode) ? acc : [...acc, cr.data.message], [])
            let conditions = conditionResponses.map((cr, j) => ([HTTP_RESPONSE_CODES.CREATED, HTTP_RESPONSE_CODES.SUCCESS, HTTP_RESPONSE_CODES.UPDATED].includes(cr.data.responseCode)) ? {
                ...cr.data.load,
                conditionCosts: cr.data.load.costResponses.map((costResp, k) =>
                    [HTTP_RESPONSE_CODES.CREATED, HTTP_RESPONSE_CODES.SUCCESS, HTTP_RESPONSE_CODES.UPDATED].includes(costResp.data.responseCode) ?
                        { ...costResp.data.load, ranges: costResp.data.load.unitCosts }
                        :
                        prevConditions[j].conditionCosts[k]
                )
            } : prevConditions[j]);
            conditionResponses.forEach(cR => {
                let crErrors = cR.data.load?.costResponses?.reduce((acc, cr) => [HTTP_RESPONSE_CODES.CREATED, HTTP_RESPONSE_CODES.SUCCESS, HTTP_RESPONSE_CODES.UPDATED].includes(cr.data.responseCode) ? acc : [...acc, cr.data.message], []) ?? []
                errors = [...crErrors, ...errors];
            });
            return {
                ...state,
                vendorConditions: {
                    ...state.vendorConditions,
                    [vendorTempId]: conditions
                },
                editingStatus: {
                    ...state.editingStatus,
                    [vendorTempId]: (closeEdition && errors.length < 1) ? false : state.editingStatus[vendorTempId]
                }
            }
        });

        builder.addCase(cancelEdit.fulfilled, (state, action) => {
            let { vendorTempId, discardVendor } = action.payload;
            if (discardVendor) {
                let remainingVendors = [...state.vendors].filter(v => !(v.tempId === vendorTempId));
                return { ...state, vendors: remainingVendors, selectedVendor: remainingVendors[0] ?? null };
            } else {
                return { ...state, editingStatus: { ...state.editingStatus, [vendorTempId]: false } }

            }
        })
    }

});

export const fetchVendorsForCost = createAsyncThunk("vendorCost/fetchVendorsForCost",
    async ({ partId, key, vendorParams }, { rejectWithValue, getState }) => {
        let response = await getPartVendors(partId, key, vendorParams);
        if (response.data.responseCode === HTTP_RESPONSE_CODES.SUCCESS) {
            return response.data.load;
        } else {
            return rejectWithValue(null);
        }
    }
)

export const fetchConditionCosts = createAsyncThunk("vendorCost/fetchConditioncosts",
    async ({ tatId, vendorTempId, conditionIdx }, { rejectWithValue, getState }) => {
        let response = await getConditionCosts(tatId);
        if (response.data.responseCode === HTTP_RESPONSE_CODES.SUCCESS) {
            return { load: response.data.load, vendorTempId, conditionIdx }
        } else {
            return rejectWithValue(null);
        }
    }
)

export const fetchRanges = createAsyncThunk("vendorCost/fetchRanges",
    async ({ costHistoryId, conditionIdx, historyIdx, vendorTempId }, { rejectWithValue, getState }) => {
        let response = await getSpecificCost(costHistoryId);
        if (response.data.responseCode === HTTP_RESPONSE_CODES.SUCCESS) {
            // return rejectWithValue(null);
            return { conditionIdx, historyIdx, vendorTempId, load: response.data.load.unitCosts };
        } else {
            return rejectWithValue(null);
        }
    }
)

export const cancelEdit = createAsyncThunk("vendorCost/cancelEdit",
    ({ vendorTempId }, { getState, rejectWithValue }) => {
        return new Promise((resolve, reject) => {
            let { vendors } = getState().vendorCost;
            if (vendors.find(v => v.tempId === vendorTempId).isNew) {
                resolve({
                    msg: "Vendor discarded",
                    vendorTempId,
                    discardVendor: true,
                })
            } else {
                resolve({
                    msg: "Changes discarded",
                    vendorTempId,
                    discardVendor: false
                })
            }
        })
    })

export const saveVendor = createAsyncThunk("vendorCost/saveVendor",
    ({ vendorTempId, partId, closeEdition }, { rejectWithValue, getState }) => {
        let { vendorConditions, selectedVendor } = getState().vendorCost;
        let conditionsToSave = vendorConditions[vendorTempId].map(c => ({ ...c, partId, vendorId: selectedVendor.vendorId, currencyId: selectedVendor.currencyId }));
        return Promise.all(conditionsToSave.map(condition =>
            saveTatInfo(condition).then(response => {

                return ([HTTP_RESPONSE_CODES.SUCCESS, HTTP_RESPONSE_CODES.CREATED, HTTP_RESPONSE_CODES.UPDATED].includes(response.data.responseCode) && condition.conditionCosts.length > 0) ?
                    Promise.all(condition.conditionCosts.map(cItem => (cItem.isNew || cItem.edited) ?
                        saveCostsReq({ ...cItem, partVendorId: response.data.load.id, unitCosts: cItem.ranges, accountId: parseInt(localStorage.getItem("u_account_id")) })
                        : Promise.resolve({ data: { load: cItem, responseCode: 204 } })
                    )).then(costResponses =>
                        ({ ...response, data: { ...response.data, load: { ...response.data.load, costResponses } } })
                    )
                    :
                    Promise.resolve(response);
            })
        )).then(conditionResponses => {
            return {
                // conditions: conditionResponses.map(r => r.data.load),
                prevConditions: conditionsToSave,
                conditionResponses: conditionResponses,
                vendorTempId,
                closeEdition
            }
        })

    }
)

// export const fetchConditionsCosts = createAsyncThunk("vendorCost/fetchConditionsCosts", 
//     async ({tatElements, vendorTempId }, {rejectWithValue, getState}) => {
//         let responses = await Promise.all(tatElements.map(tatItem => getConditionCosts(tatItem.id)));
//         if (responses.every(r => r.data.responseCode = HTTP_RESPONSE_CODES.SUCCESS)) {
//             return {
//                 vendorTempId,
//                 loads: responses.map(r => r.data.load),
//                 messages: responses.map(r=>r.data.message),
//                 codes: responses.map(r => r.data.responsecode)
//             };
//         }
//         else {
//             return rejectWithValue(null)
//         }


//     }
// )

const defaultUnitCost = {
    id: null,
    range: "",
    unitCost: null,
    version: 0
}

const defaultHistoryPrice = () => ({
    id: null,
    initialDate: null,
    finalDate: null,
    minUnitCost: null,
    isNew: true,
    costType: "F",
    unitCosts: [{ ...defaultUnitCost }],
    ranges: [{ ...defaultUnitCost }],
    edited: true
})

const defaultTat = (key) => ({
    "version": 0,
    "id": null,
    "partId": null,
    "vendorId": null,
    "currencyId": null,
    "partConditionId": null,
    "repairTypeId": null,
    "accountId": localStorage.getItem('u_account_id'),
    "tat_estimated": null,
    "tat_average": null,
    "warranty_hours": null,
    "warranty_cycles": null,
    "warranty_aircraft_days": null,
    "warranty_calendar_days": null,
    "type": key
});

export const fetchTATInfo = createAsyncThunk("vendorCost/fetchTATInfo",
    async ({ partId, vendorId, vendorTempId, partConditions, costType }, { rejectWithValue, getState }) => {
        // console.warn("getting tat for:", partId, vendorId, conditionId);
        // if (!([partId, vendorId, conditionId].every(param => typeof (param) === 'number'))) {
        //     return { load: { ...defaultTat }, vendorId, conditionId, vendorTempId };
        // };
        // FIXME:
        // console.warn('*fetchTATInfo params', partId, vendorId, vendorTempId, partConditionIds, costType);
        let responses = typeof (vendorId) === 'number' ? await getTATInfo(partId, vendorId, partConditions.map(c => c.id), costType) : [];
        if (responses.every(r => r.load)) {
            let firstNonNullTAT = responses.find(r => typeof (r.load.id) === 'number').load;
            let preSelectedTab = firstNonNullTAT ? (partConditions.find(c => c.id === firstNonNullTAT[conditionProp[costType]]) ?? null) : null;
            let { currencyId, vendorId } = firstNonNullTAT ?? { currencyId: null, vendorId: null };
            return { load: responses.filter(r => typeof (r.load.id) === 'number').map(r => r.load), vendorTempId, partConditions, currencyId, vendorId, preSelectedTab }
        } else {
            return rejectWithValue(null);
        }
        // if (response.data.responseCode === HTTP_RESPONSE_CODES.SUCCESS) {
        //     return { load: response.data.load, vendorId, conditionId: conditionId, vendorTempId };
        // } else {
        //     return rejectWithValue(null);
        // }
    }
)


// export const saveTATInfo = createAsyncThunk("vendorCost/saveTATInfo",
//     async ({ closeEdition, vendorTempId, partId, costType }, { rejectWithValue, getState }) => {
//         console.warn('saving tat info', vendorTempId, closeEdition);
//         let { tatInfo, vendorVendor, vendorCurrency } = getState().vendorCost;
//         let bodyArr = Object.entries(tatInfo[vendorTempId]).map(([conditionId, tatConditionInfo]) => ({
//             ...tatConditionInfo, repairTypeId: costType === "R" ? parseInt(conditionId) : null, partConditionId: costType === "C" ? parseInt(conditionId) : null, partId, companyId: localStorage.getItem('u_company_id'), vendorId: vendorVendor[vendorTempId], currencyId: vendorCurrency[vendorTempId]
//         }))
//         console.warn('saving tat info...', bodyArr);
//         let responses = await saveTatInfo(bodyArr, partId);
//         if (responses.every(r => [HTTP_RESPONSE_CODES.CREATED, HTTP_RESPONSE_CODES.SUCCESS, HTTP_RESPONSE_CODES.UPDATED].includes(r.data.responseCode))) {
//             let load = Object.fromEntries(responses.map(r => [costType === "C" ? r.data.load.partConditionId : r.data.load.repairTypeId, r.data.load]))
//             return { load, closeEdition, vendorTempId, codes: responses.map(r => r.data.responseCode), messages: responses.map(r => r.data.message) }
//         } else {
//             return rejectWithValue({ load: null, codes: responses.map(r => r.data.responseCode), messages: responses.map(r => r.data.message) });
//         }
//         // let response = await saveTatInfo(tat);
//         // if ([HTTP_RESPONSE_CODES.CREATED, HTTP_RESPONSE_CODES.SUCCESS, HTTP_RESPONSE_CODES.UPDATED].includes(response.data.responseCode)) {
//         //     return { data: response.data, closeEdition, vendorTempId };
//         // } else {
//         //     return rejectWithValue({ data: response.data });
//         // }
//     }
// )

export const deleteTATInfo = createAsyncThunk("vendorCost/deleteTATInfo",
    async ({ tatInfoId, vendorTempId, conditionId }, { rejectWithValue, getState }) => {
        let response = await deleteTatInfo(tatInfoId);
        if (response.data.responseCode === HTTP_RESPONSE_CODES.DELETED) {
            return { ...response.data, tatInfoId, vendorTempId, conditionId }
        } else {
            return rejectWithValue(response.data);
        }
    }
)

// export const saveCosts = createAsyncThunk("vendorCost/saveCosts",
//     async ({ vendorTempId, conditionId, tatId }, { rejectWithValue, getState }) => {
//         let { conditionCosts } = getState().vendorCost;
//         let currentCosts = ([...conditionCosts] ?? [])?.[vendorTempId]?.[conditionId] ?? [];
//         let editableCosts = currentCosts.map(c => ({ ...c, partVendorId: tatId, companyId: parseInt(localStorage.getItem('u_company_id')), unitCosts: c.unitCosts.map(uC => ({ ...uC, companyId: localStorage.getItem('u_company_id') })) }));
//         // if (editableCosts)
//         console.warn('*editable costs', editableCosts);
//         let responses = await Promise.all(editableCosts.map(cItem => saveCostsReq(cItem)));
//         console.warn('*responses', responses);
//         if (responses.every(r => [HTTP_RESPONSE_CODES.CREATED, HTTP_RESPONSE_CODES.SUCCESS, HTTP_RESPONSE_CODES.UPDATED].includes(r.data.responseCode))) {
//             return {
//                 codes: responses.map(r => r.data.responseCode),
//                 messages: responses.map(r => r.data.message),
//                 loads: responses.map(r => r.data.load),
//                 vendorTempId,
//                 conditionId
//             }
//         } else {
//             return rejectWithValue(null);
//         }


//     }
// )

export const fetchCurrencies = createAsyncThunk("vendorCost/fetchCurrencies",
    async ({ a }, { getState, rejectWithValue }) => {
        let response = await getCurrencies();
        if (response.data.responseCode === HTTP_RESPONSE_CODES.SUCCESS) {
            return response.data.load;
        } else {
            return rejectWithValue(null);
        }
    }
);

export const fetchConditions = createAsyncThunk("vendorCost/fetchConditions",
    async ({ costType }, { rejectWithValue }) => {
        let response = await getPartConditions(costType);
        if (response.data.responseCode === HTTP_RESPONSE_CODES.SUCCESS) {
            return { conditions: response.data.load, costType };
        } else {
            return rejectWithValue(null);
        }
    }
)

export const { addNewVendor, updateVendorParams, updateCostType, resetSlice, startEdition, discardCondition, cancelEdition, selectVendor, tabChange, applyConditions, vendorChange, currencyChange, updateVendorCondition, updateCostItem, updateRange, addRange, removeRange, addCost } = vendorCostSlice.actions;

export const selectPartVendors = (state) => state.vendorCost.vendors;
export const selectSelectedVendor = (state) => state.vendorCost.selectedVendor;
export const selectEditingStatus = (state) => state.vendorCost.editingStatus;
export const selectUnsaved = (state) => state.vendorCost.unsaved;
export const selectGeneralConditions = (state) => state.vendorCost.conditions;
export const selectCostType = (state) => state.vendorCost.costType;
export const selectVendorConditions = (state, vendorTempId) => state.vendorCost.vendorConditions[vendorTempId];
export const selectAllVendorConditions = (state) => state.vendorCost.vendorConditions;
export const selectCurrentTab = (state) => state.vendorCost.tab;
export const selectIdxConditions = (state) => state.vendorCost.idxConditions;
export const selectLoading = (state) => state.vendorCost.loading;
export const selectCurrencies = (state) => state.vendorCost.currencies;
export const selectVendorParams = (state) => state.vendorCost.vendorParams;
// export const selectCostItem = (state, vendorTempId, conditionId) => state.vendorCost[vendorTempId][conditionId]


export default vendorCostSlice.reducer;